module.exports = "<div ng-if=\"tabs.length > 1\" class=\"tabContainer\">\n    <div class=\"tab\"\n        ng-repeat=\"tab in tabs\"\n        ng-class=\"{ active: actions.getTabIsActive(tab) }\"\n        ng-click=\"!actions.getTabIsActive(tab) && onSelect(tab)\"\n        ng-bind-html=\"tab.label\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-ui-components/src/tabs/template.html
// module id = ../node_modules/xo-ui-components/src/tabs/template.html
// module chunks = 0